import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/EventList/EventList.tsx");
